import { InformationsPreAssurabilite } from "../../models";
import i18n from "../../resources/I18n";
import { INavigationParcours, obtenirNavigationUrl } from "../../util/Navigation";
import { DsdButton } from "../DSD/DsdButton";
import { DsdColumn } from "../DSD/DsdColumn";
import { DsdRow } from "../DSD/DsdRow";
import { getMetaTagContent } from "../../scripts/getMetaTag";
import ModaleEnregistrer from "../AMC/ModaleEnregistrer";
import ModaleAnnuler from "../AMC/ModaleAnnuler";
import ModaleDonnerControle from "../AMC/ModaleDonnerControle";
import * as TYPE_PARCOURS from "../../constants/typeParcours";
import * as ConstantesAssurabilite from "../../constants/assurabilite";
import "./boutons.css"

interface IBoutonsProps {
  onClickContinuer: () => void;
  onClickEtatModaleEnregistrer: (etat: boolean, declencheur: string) => void;
  onClickEtatModaleAnnuler: (etat: boolean, declencheur: string) => void;
  onClickEtatModaleDonnerControle: (etat: boolean, declencheur: string) => void;
  modaleEnregistrerOuvert: boolean;
  modaleAnnulerOuvert: boolean;
  modaleDonnerControleOuvert: boolean;
  informationsPreAssurabilite: InformationsPreAssurabilite;
  cookieParcoursAssurance: INavigationParcours;
  showBtnContinuer?: boolean;
  showVerdict?: boolean;
  parcours: string;
  estNouvelleMarge: boolean;
  estEmprunteurPrimaire: boolean;
}

function Boutons(props: Readonly<IBoutonsProps>) {
  const onClickBoutonPrecedent = () => {
    const isApp = getMetaTagContent("oel-is-app") ?? false;
    window.location.assign(
      `${obtenirNavigationUrl(props.cookieParcoursAssurance.idCallback)}${props.parcours}/${
        props.cookieParcoursAssurance.langue
      }/back?idSouscription=${props.cookieParcoursAssurance.idSouscription}&idAssure=${
        props.cookieParcoursAssurance.idAssure
      }&isApp=${isApp}`
    );
  };

  const afficherModaleEnregistrer = () => {
    props.onClickEtatModaleEnregistrer(true, "btn-enregistrer-amc");
  };

  const afficherModaleAnnuler = () => {
    props.onClickEtatModaleAnnuler(true, "btn-annuler-amc");
  };

  const afficherModaleDonnerControle = () => {
    props.onClickEtatModaleDonnerControle(true, "btn-donner-controle-amc");
  };

  return (
    <>
      <ModaleEnregistrer
        modaleOuvert={props.modaleEnregistrerOuvert}
        onClickModaleEnregistrerFermer={props.onClickEtatModaleEnregistrer}
        dateExpirationOffre={props.informationsPreAssurabilite.dateExpirationOffre}
        cookieParcoursAssurance={props.cookieParcoursAssurance}
        parcours={props.parcours}
      />
      <ModaleAnnuler
        modaleAnnulerOuvert={props.modaleAnnulerOuvert}
        onClickModaleAnnulerFermer={props.onClickEtatModaleAnnuler}
        cookieParcoursAssurance={props.cookieParcoursAssurance}
        parcours={props.parcours}
        estEmprunteurPrimaire={props.estEmprunteurPrimaire}
        estNouvelleMarge={props.estNouvelleMarge}
      />
      <ModaleDonnerControle
        modaleDonnerControleOuvert={props.modaleDonnerControleOuvert}
        onClickModaleDonnerControleFermer={props.onClickEtatModaleDonnerControle}
        cookieParcoursAssurance={props.cookieParcoursAssurance}
        parcours={props.parcours}
      />
      <DsdRow id="boutons-container-amc">
        <DsdColumn>
          <div className={props.parcours === TYPE_PARCOURS.ASSISTE ? "dsd-button-group bouton-group-assiste" : "dsd-button-group"}>
            {props.showVerdict &&
              (props.informationsPreAssurabilite.decision === "ACC" ||
                props.informationsPreAssurabilite.exigence === "RA") && (
                <DsdButton
                  datatestid="btn-continuer-amc"
                  variant="primary"
                  id="btn-continuer-amc"
                  onClick={props.onClickContinuer}
                >
                  {i18n.t("amc:btn-continuer")}
                </DsdButton>
              )}
            <DsdButton id="btn-precedent-amc" datatestid="btn-precedent-amc" onClick={onClickBoutonPrecedent}>
              {i18n.t("amc:btn-precedent")}
            </DsdButton>
            <DsdButton
              key={props.estNouvelleMarge ? ConstantesAssurabilite.NOUVELLE : ConstantesAssurabilite.CHANGEMENT}
              id="btn-annuler-amc"
              datatestid="btn-annuler-amc"
              onClick={afficherModaleAnnuler}
            >
              {props.estNouvelleMarge
                ? i18n.t("amc:btn-annuler-nouvelle-marge")
                : i18n.t("amc:btn-annuler-changement-limite")}
            </DsdButton>
            <DsdButton id="btn-enregistrer-amc" datatestid="btn-enregistrer-amc" onClick={afficherModaleEnregistrer}>
              {i18n.t("amc:btn-enregistrer")}
            </DsdButton>
            {props.parcours === TYPE_PARCOURS.ASSISTE && (       
            <DsdButton id="btn-donner-controle-amc" datatestid="btn-donner-controle-amc" onClick={afficherModaleDonnerControle}>
              {i18n.t("amc:btn-donner-controle")}
              <span className="dsd-sr-only">{i18n.t("amc:btn-donner-controle-au-membre")}</span>
            </DsdButton>)}
          </div>
        </DsdColumn>
      </DsdRow>
    </>
  );
}

export default Boutons;
